/* Product page: set sheet (case + wallet + AirPods case, or a gift for family and friends).
   Items are added with /cart/add.js; the main case goes through the theme's own form so the drawer and tracking behave as before.
   Prices shown are the real item totals; a saving is shown only when the merchant switched "Set prices are set up in Shopify" on.
   Matching: add-ons follow the case colour when their colour has a readable name, and the AirPods case follows the AirPods the shopper picks. */
(function () {
  'use strict';
  var el = document.querySelector('pm-set');
  if (!el) return;
  var cfg;
  try { cfg = JSON.parse(el.querySelector('script').textContent); } catch (e) { return; }
  document.documentElement.classList.add('pm-set-b');
  var form = document.querySelector('product-form form') || document.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  cfg.screens = cfg.screens || [];
  /* a kind only joins a set once enough of it is in stock, so a half-stocked range never shows one lonely item; screen protectors join from the first one */
  var MINK = parseInt(el.getAttribute('data-min'), 10) || 1;
  ['wallets', 'airpods', 'straps', 'lens'].forEach(function (k) { if ((cfg[k] || []).length < MINK) cfg[k] = []; });
  var main = cfg.main, cur = el.getAttribute('data-cur') || 'USD', shopCur = el.getAttribute('data-shopcur') || 'USD';
  var live = el.getAttribute('data-live') === 'true' && cur === shopCur;
  var p2 = Math.round(parseFloat(el.getAttribute('data-p2')) * 100) || 0;
  var p3 = Math.round(parseFloat(el.getAttribute('data-p3')) * 100) || 0;
  var freeFrom = parseFloat(el.getAttribute('data-free')) * 100 || 0;
  var shipText = el.getAttribute('data-ship') || '';
  var halloween = document.documentElement.classList.contains('pm-halloween');
  var code = (el.getAttribute('data-code') || '').trim(), codeMin = Math.round(parseFloat(el.getAttribute('data-codemin')) * 100) || 0, codeText = el.getAttribute('data-codetext') || '';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function low(s) { return String(s == null ? '' : s).replace(/[\s ]+/g, ' ').trim().toLowerCase(); }
  function money(c) {
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(c / 100); }
    catch (e) { return '$' + (c / 100).toFixed(2); }
  }
  function img(u, w) {
    if (!u) return '';
    if (u.indexOf('http') !== 0 && u.charAt(0) !== '/') u = '/cdn/shop/' + u;
    return String(u).replace(/(\.[a-z0-9]+)(\?|$)/i, '_' + w + 'x$1$2');
  }
  function modelIdx(p) {
    for (var i = 0; i < p.options.length; i++) {
      for (var j = 0; j < p.variants.length; j++) { if (low(p.variants[j].options[i]).indexOf('iphone') !== -1) return i; }
    }
    return -1;
  }
  /* accessory mode: the viewed product is not an iPhone case (strap, wallet, AirPods case, ...). The phone comes from what the shopper chose before, and a case becomes one of the add-ons. */
  var acc = el.getAttribute('data-acc') || '';
  var PHONES = ['iPhone Duo', 'iPhone 18 Pro Max', 'iPhone 18 Pro', 'iPhone 17 Pro Max', 'iPhone 17 Pro', 'iPhone 17', 'iPhone 16 Pro Max', 'iPhone 16 Pro', 'iPhone 16', 'iPhone 15 Pro Max', 'iPhone 15'];
  var phone = '';
  try { phone = localStorage.getItem('user_selected_device_model') || ''; } catch (e) { phone = ''; }
  var mIdx = modelIdx(main);
  if (mIdx < 0 && !acc) return;
  var cIdx = -1;
  for (var q = 0; q < main.options.length; q++) { if (q !== mIdx) { cIdx = q; break; } }

  /* colour families: only readable names count; supplier codes such as "151F" are unknown */
  var FAMILIES = [
    ['white', /gr[ae]y ?white|white ?gr[ae]y|off-?white/], ['clear', /clear|transparent/], ['black', /black|balck|onyx|midnight/], ['gray', /gr[ae]y|silver|graphite|slate|titanium/],
    ['white', /white|ivory|cream|milk|snow|pearl|off-?white/], ['pink', /pink|rose|blush|peach|salmon/], ['red', /\bred\b|burgundy|wine|maroon|crimson/],
    ['orange', /orange|coral|rust|terracotta/], ['yellow', /yellow|gold|mustard|lemon/], ['green', /green|olive|sage|mint|forest|emerald/],
    ['blue', /blue|navy|teal|cyan|aqua/], ['purple', /purple|lilac|violet|lavender|plum|mauve/], ['brown', /brown|tan|camel|coffee|chocolate|khaki|beige|sand/]
  ];
  function family(v) {
    var t = low(v);
    for (var i = 0; i < FAMILIES.length; i++) { if (FAMILIES[i][1].test(t)) return FAMILIES[i][0]; }
    return '';
  }
  /* AirPods model names differ from product to product: map each to the models it fits */
  var AP_ORDER = ['AirPods Pro 2', 'AirPods Pro 3', 'AirPods 4', 'AirPods 3', 'AirPods Pro', 'AirPods 1 or 2'];
  function apModels(txt) {
    var t = low(txt).replace(/\s+/g, ' '), out = [];
    if (/pro ?3/.test(t)) out.push('AirPods Pro 3');
    if (/pro ?2|pro or pro 2/.test(t)) out.push('AirPods Pro 2');
    if (/pro or pro 2/.test(t) || (!/pro ?[23]/.test(t) && /airpods ?pro/.test(t))) out.push('AirPods Pro');
    if (/(air)?pods ?4/.test(t)) out.push('AirPods 4');
    if (/(air)?pods ?3(?!\w)/.test(t) && !/pro/.test(t)) out.push('AirPods 3');
    if (/1 or 2|1\/2/.test(t)) out.push('AirPods 1 or 2');
    return out.filter(function (m, i) { return out.indexOf(m) === i; });
  }
  function optIdxApModel(p) {
    for (var i = 0; i < p.options.length; i++) {
      for (var j = 0; j < p.variants.length; j++) { if (/airpods?/i.test(p.variants[j].options[i])) return i; }
    }
    return -1;
  }
  function optIdxColour(p, skip) {
    for (var i = 0; i < p.options.length; i++) { if (i !== skip && /colo/i.test(p.options[i])) return i; }
    for (var k = 0; k < p.options.length; k++) { if (k !== skip) return k; }
    return -1;
  }

  function variantById(p, id) { for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].id === +id) return p.variants[i]; } return null; }
  /* the set data only lists in-stock variants, so a sold-out choice is rebuilt from the Aura data (all variants) and marked unavailable */
  var auAll = null;
  function soldOutVariant(id) {
    if (!auAll) {
      auAll = {};
      try { JSON.parse(document.getElementById('pm-au-data').textContent).variants.forEach(function (v) { auAll[v.id] = v; }); } catch (e) { auAll = {}; }
    }
    var a = auAll[id];
    if (a) return { id: +a.id, options: a.o, price: a.p, available: false, featured_image: null };
    var f = main.variants[0];
    return { id: +id || f.id, options: f.options, price: f.price, available: false, featured_image: f.featured_image };
  }
  function curVariant() {
    var inp = form.querySelector('[name="id"]');
    if (!inp || !inp.value) return main.variants[0];
    return variantById(main, inp.value) || soldOutVariant(inp.value);
  }
  function modelVal() { return mIdx >= 0 ? curVariant().options[mIdx] : (phone || 'iPhone'); }
  function phoneNow() { return mIdx >= 0 ? curVariant().options[mIdx] : phone; }
  function colourVal() { return cIdx < 0 ? '' : curVariant().options[cIdx]; }

  var audience = window.__pmsAud || '';
  var HER = ['cute', 'pearl', 'floral', 'pink', 'heart', 'sparkle', 'bow', 'pastel'];
  var HIM = ['carbon', 'leather', 'black', 'metal', 'matte', 'armor'];
  function audScore(p) {
    var t = low(p.title), words = audience === 'female' ? HER : audience === 'male' ? HIM : [], n = 0;
    words.forEach(function (w) { if (t.indexOf(w) !== -1) n++; });
    return n;
  }

  /* best variant per product: same colour family first, then readable colours, then supplier codes */
  function bestFor(p, fits) {
    var ci = optIdxColour(p, p._skip), want = family(colourVal()), best = null;
    p.variants.forEach(function (v) {
      if (!v.available || (fits && !fits(v, p))) return;
      var f = ci < 0 ? '' : family(v.options[ci]), s;
      if (want && f && f === want) s = 100;
      else if (f) s = 20;
      else s = 10;
      if (!best || s > best.score) best = { p: p, v: v, score: s, exact: s === 100, fam: f };
    });
    var ov = best && st.vo && st.vo[p.handle] ? variantById(p, st.vo[p.handle]) : null;
    if (ov && ov.available && (!fits || fits(ov, p))) {
      var of = ci < 0 ? '' : family(ov.options[ci]);
      best = { p: p, v: ov, score: best.score, exact: !!(want && of && of === want), fam: of };
    }
    return best;
  }
  function rank(list, fits) {
    var out = [];
    list.forEach(function (p) {
      var b = bestFor(p, fits);
      if (b) { b.score += audScore(p); out.push(b); }
    });
    out.sort(function (a, b) { return b.score - a.score; });
    return out;
  }

  /* ---- state ---- */
  var storedAp = '';
  try { storedAp = localStorage.getItem('pm_airpods_model') || ''; } catch (e) { storedAp = ''; }
  var st = { tier: 'set', apModel: storedAp, apPick: 0, wlPick: 0, gift: ['', ''], busy: false, err: '', stage: 'pick', added: [], inc: null, touched: false, stPick: 0, lnPick: 0, scPick: 0, csPick: 0, open: '', vo: {}, codeOn: false, yay: false, yayUntil: 0 };
  cfg.airpods.forEach(function (p) { p._skip = optIdxApModel(p); });
  cfg.wallets.forEach(function (p) { p._skip = -1; });

  function apAvailableModels() {
    var seen = {};
    cfg.airpods.forEach(function (p) {
      if (p._skip < 0) return;
      p.variants.forEach(function (v) { if (v.available) apModels(v.options[p._skip]).forEach(function (m) { seen[m] = true; }); });
    });
    return AP_ORDER.filter(function (m) { return seen[m]; });
  }
  function apCandidates(model) {
    var out = [];
    cfg.airpods.forEach(function (p) {
      var mi = p._skip;
      var b = bestFor(p, function (v) { return mi >= 0 && apModels(v.options[mi]).indexOf(model) !== -1; });
      if (b) { b.score += audScore(p); out.push(b); }
    });
    out.sort(function (a, b) { return b.score - a.score; });
    return out;
  }
  function wlCandidates() { return rank(cfg.wallets.filter(function (p) { return p.handle !== main.handle; }), null); }

  /* ---- cases for the shopper's phone (accessory pages): fetched from the model collection, in-stock variants only ---- */
  cfg.cases = [];
  var casePhone = '';
  function caseSlug(m) { return 'iphone-' + low(m).replace('iphone', '').trim().replace(/\s+/g, '-') + '-cases'; }
  function toSetProduct(p) {
    var opts = (p.options || []).map(function (o) { return o.name || o; });
    var vs = (p.variants || []).filter(function (v) { return v.available; }).map(function (v) {
      return { id: v.id, options: [v.option1, v.option2, v.option3].slice(0, opts.length), price: Math.round(parseFloat(v.price) * 100) || 0, available: true, featured_image: (v.featured_image && v.featured_image.src) || null };
    });
    return { handle: p.handle, title: p.title, tags: p.tags || [], options: opts, featured_image: (p.images && p.images[0] && p.images[0].src) || null, variants: vs };
  }
  function loadCases() {
    var m = phoneNow();
    if (!acc || !m || m === casePhone) return;
    casePhone = m;
    fetch('/collections/' + caseSlug(m) + '/products.json?limit=24').then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (j) {
      if (m !== casePhone) return;
      cfg.cases = (j.products || []).filter(function (p) { return p.handle !== main.handle; }).map(toSetProduct).filter(function (p) { return p.variants.length; });
      cfg.cases.forEach(function (p) { p._skip = modelIdx(p); });
      if (!st.touched) st.inc = null;
      teaser(); rerender();
    }).catch(function () { cfg.cases = []; });
  }
  function caseCands() {
    var m = low(phoneNow());
    return m ? rank(cfg.cases, function (v, p) { var mi = modelIdx(p); return mi < 0 || low(v.options[mi]) === m; }) : [];
  }
  function pickCase() { var c = caseCands(); return st.inc && st.inc.case ? (c[Math.min(st.csPick, c.length - 1)] || null) : null; }
  function phoneChips() {
    var h = '<div class="pms-models">';
    PHONES.forEach(function (m) { h += '<button type="button" class="pms-mdl" data-phone="' + esc(m) + '">' + esc(m.replace('iPhone ', '')) + '</button>'; });
    return h + '</div>';
  }
  function pickAp(model) { var c = apCandidates(model); return c[Math.min(st.apPick, c.length - 1)] || null; }
  function pickWl() { var c = wlCandidates(); return c[Math.min(st.wlPick, c.length - 1)] || null; }


  /* ---- optional extras: strap or lanyard, camera lens protector ---- */
  var recent = [];
  try { var rm = document.cookie.match(/(?:^|; )recentproducts=([^;]*)/); if (rm) recent = decodeURIComponent(rm[1]).split('+'); } catch (e) { recent = []; }
  var remembered = {};
  try { remembered = JSON.parse(localStorage.getItem('pm_extras') || '{}') || {}; } catch (e) { remembered = {}; }
  function tagsOf(p) { return (p.tags || []).map(low); }
  var AUD_TAGS = ['audience-her', 'audience-him', 'audience-all'];
  function extraScore(p) {
    var t = tagsOf(p), s = 0, mt = tagsOf(main);
    if (audience === 'female') { if (t.indexOf('audience-her') > -1) s += 50; else if (t.indexOf('audience-all') > -1) s += 15; else if (t.indexOf('audience-him') > -1) s -= 25; }
    else if (audience === 'male') { if (t.indexOf('audience-him') > -1) s += 50; else if (t.indexOf('audience-all') > -1) s += 15; else if (t.indexOf('audience-her') > -1) s -= 25; }
    else if (t.indexOf('audience-all') > -1) s += 10;
    t.forEach(function (x) { if (AUD_TAGS.indexOf(x) < 0 && mt.indexOf(x) > -1) s += 4; });
    if (recent.indexOf(p.handle) > -1) s += 40;
    if (remembered[p.handle]) s += 25;
    return s;
  }
  function rankExtras(list, fits, keepCase) {
    var out = [];
    list.forEach(function (p) {
      if (!keepCase && /\bcase\b/i.test(p.title)) return;
      var b = bestFor(p, fits);
      if (!b) return;
      var pt = tagsOf(p);
      b.score = (b.exact ? 40 : b.score >= 20 ? 10 : 5) + extraScore(p);
      b.reason = recent.indexOf(p.handle) > -1 ? 'You viewed this' : remembered[p.handle] ? 'You picked this before' : b.exact ? 'Matches your ' + colourVal() + ' case' :
        ((audience === 'female' && pt.indexOf('audience-her') > -1) || (audience === 'male' && pt.indexOf('audience-him') > -1)) ? 'Picked for your style' : 'Popular pick';
      out.push(b);
    });
    out.sort(function (a, b) { return b.score - a.score; });
    return out;
  }
  function strapCands() { return rankExtras(cfg.straps || [], null); }
  function lensCands() {
    var m = low(modelVal());
    return rankExtras(cfg.lens || [], function (v, p) { var mi = modelIdx(p); return mi < 0 || low(v.options[mi]) === m; });
  }
  /* screen protectors: the layer picks itself up the moment the collection has products that fit the shopper's iPhone */
  function screenCands() {
    var m = low(modelVal());
    return rankExtras(cfg.screens, function (v, p) { var mi = modelIdx(p); return mi < 0 || low(v.options[mi]) === m; }, true);
  }
  function pickSc() { var c = screenCands(); return st.inc && st.inc.screen ? (c[Math.min(st.scPick, c.length - 1)] || null) : null; }
  function pickSt() { var c = strapCands(); return st.inc && st.inc.strap ? (c[Math.min(st.stPick, c.length - 1)] || null) : null; }
  function pickLn() { var c = lensCands(); return st.inc && st.inc.lens ? (c[Math.min(st.lnPick, c.length - 1)] || null) : null; }
  function rememberExtra(handle) {
    remembered[handle] = Date.now();
    try { localStorage.setItem('pm_extras', JSON.stringify(remembered)); } catch (e) { /* storage blocked */ }
  }


  /* ---- predictive set: the add-ons that make most sense for this shopper are included, the rest are one tap away ---- */
  /* the viewed product is never offered again as an add-on of its own kind */
  var TYPES = acc ? ({ strap: ['case', 'wallet', 'screen'], wallet: ['case', 'strap', 'screen'], airpods: ['case', 'strap', 'wallet'] }[acc] || ['case', 'wallet', 'strap']) : ['wallet', 'airpods', 'screen', 'strap', 'lens'];
  var NAMES = { wallet: 'wallet', airpods: 'AirPods case', strap: 'strap', lens: 'lens protector', screen: 'screen protector', 'case': acc ? 'iPhone case' : 'case' };
  var MAIN_NAME = { strap: 'strap', wallet: 'wallet', airpods: 'AirPods case' }[acc] || 'item';
  function recentHas(list) { return (list || []).some(function (p) { return recent.indexOf(p.handle) > -1; }); }
  function rememberedHas(list) { return (list || []).some(function (p) { return remembered[p.handle]; }); }
  function typeCands(k) {
    return k === 'case' ? caseCands() : k === 'wallet' ? wlCandidates() : k === 'airpods' ? apCandidates(st.apModel || 'AirPods Pro 2') : k === 'strap' ? strapCands() : k === 'screen' ? screenCands() : lensCands();
  }
  function typeAvail(k) {
    if (k === 'case') return !phoneNow() || caseCands().length > 0; /* without a phone the case stays one tap away */
    if (k === 'airpods') return cfg.airpods.length > 0 && apAvailableModels().length > 0 && typeCands('airpods').length > 0;
    if (k === 'strap') return strapCands().length > 0 && (audience !== 'male' || recentHas(cfg.straps) || rememberedHas(cfg.straps));
    return typeCands(k).length > 0;
  }
  function predictInc() {
    var views = recent.filter(function (h) { return h !== main.handle; }).length;
    var intent = Math.min(3, views) + (storedAp ? 2 : 0) + Math.min(2, Object.keys(remembered).length);
    var thr = intent >= 4 ? 45 : intent >= 2 ? 52 : 60;
    var sc = { 'case': phoneNow() ? 95 : 0, screen: 70, wallet: 60, airpods: 55, strap: audience === 'female' ? 80 : audience === 'male' ? 10 : 35, lens: 50 };
    if (audience === 'male') { sc.wallet += 10; sc.lens += 15; }
    if (storedAp) sc.airpods += 25;
    if (recentHas(cfg.airpods)) sc.airpods += 20;
    if (recentHas(cfg.wallets)) sc.wallet += 15;
    if (recentHas(cfg.straps)) sc.strap += 30;
    if (recentHas(cfg.lens)) sc.lens += 20;
    if (recentHas(cfg.screens)) sc.screen += 20;
    if (rememberedHas(cfg.screens)) sc.screen += 20;
    if (rememberedHas(cfg.straps)) sc.strap += 20;
    if (rememberedHas(cfg.lens)) sc.lens += 20;
    if (/pro/i.test(modelVal())) sc.lens += 10;
    var order = TYPES.filter(typeAvail).sort(function (a, b) { return sc[b] - sc[a]; });
    var inc = {}, n = 0;
    order.forEach(function (k) { if (n < (acc ? 2 : 4) && sc[k] >= thr) { inc[k] = true; n++; } });
    if (!n && order.length) inc[order[0]] = true;
    return inc;
  }
  function ensureInc() { if (!st.inc) st.inc = predictInc(); }

  function giftModels() {
    var c = low(colourVal()), out = [];
    main.variants.forEach(function (v) {
      if (!v.available) return;
      if (cIdx >= 0 && low(v.options[cIdx]) !== c) return;
      if (out.indexOf(v.options[mIdx]) === -1) out.push(v.options[mIdx]);
    });
    return out;
  }
  function giftVariant(model) {
    var c = low(colourVal());
    for (var i = 0; i < main.variants.length; i++) {
      var v = main.variants[i];
      if (v.available && low(v.options[mIdx]) === low(model) && (cIdx < 0 || low(v.options[cIdx]) === c)) return v;
    }
    return null;
  }

  function totals() {
    ensureInc();
    var cv = curVariant(), inc = st.inc, guess = !st.apModel;
    var kc = pickCase(), w = inc.wallet ? pickWl() : null, a = inc.airpods ? pickAp(st.apModel || 'AirPods Pro 2') : null, sx = pickSt(), ln = pickLn(), scr = pickSc();
    var items = [kc, w, a, scr, sx, ln].filter(Boolean);
    var t = { case1: cv.price, set: null, gift: null, kase: kc, wallet: w, ap: a, strap: sx, lens: ln, screen: scr, items: items, apGuess: guess && !!a };
    if (cv.available && items.length) {
      var sum = cv.price + items.reduce(function (n, x) { return n + x.v.price; }, 0), saved = 0;
      if (live && p2 && w && a) { var trio = cv.price + w.v.price + a.v.price; if (p2 < trio) saved = trio - p2; }
      t.set = { sum: sum, price: sum - saved, saved: saved, count: 1 + items.length };
    }
    var ok = !acc && cv.available && st.gift.every(function (m) { return m && giftVariant(m); });
    if (ok) {
      var gs = cv.price + st.gift.reduce(function (n, m) { return n + giftVariant(m).price; }, 0);
      t.gift = { sum: gs, price: live && p3 && p3 < gs ? p3 : gs, saved: live && p3 && p3 < gs ? gs - p3 : 0 };
    }
    return t;
  }
  function setNames(t) {
    var n = [MAIN_NAME === 'item' && !acc ? 'case' : MAIN_NAME];
    [['case', t.kase], ['wallet', t.wallet], ['airpods', t.ap], ['screen', t.screen], ['strap', t.strap], ['lens', t.lens]].forEach(function (e) { if (e[1]) n.push(NAMES[e[0]]); });
    var last = n.pop();
    return (n.length ? n.join(', ') + ' and ' : '') + last;
  }

  /* ---- markup ---- */
  var root = document.createElement('div');
  root.className = 'pms-root';
  el.appendChild(root);
  var sheet = null, lastFocus = null;

  function teaser() {
    var t = totals();
    if (!t.set) { root.innerHTML = ''; el.hidden = true; return; }
    el.hidden = false;
    var name = halloween ? 'Spooky protection set' : (acc ? 'Complete your set' : 'Complete protection set');
    var thumbs = '<i style="background-image:url(' + esc(img(curVariant().featured_image || main.featured_image, 120)) + ')"></i>';
    t.items.slice(0, 2).forEach(function (x) { thumbs += '<i style="background-image:url(' + esc(img(x.v.featured_image || x.p.featured_image, 120)) + ')"></i>'; });
    var cap = setNames(t);
    root.innerHTML = '<button type="button" class="pms-teaser" data-open>' +
      '<span class="pms-thumbs">' + thumbs + '</span>' +
      '<span class="pms-tt"><b>' + name + '</b><small>' + esc(cap.charAt(0).toUpperCase() + cap.slice(1)) + ' for your ' + esc(modelVal()) + '</small></span>' +
      '<span class="pms-go">' + (t.set.saved ? 'Save ' + money(t.set.saved) : (t.apGuess ? 'From ' : '') + money(t.set.price)) + ' &rsaquo;</span></button>';
  }

  function tierBtn(key, name, sub, price, was, tagTxt, items) {
    var on = st.tier === key;
    return '<button type="button" class="pms-tier' + (on ? ' is-on' : '') + '" data-tier="' + key + '" aria-pressed="' + on + '">' +
      (tagTxt ? '<span class="pms-tag">' + tagTxt + '</span>' : '') +
      '<span class="pms-dot"></span><span class="pms-tx"><b>' + name + '</b><small>' + sub + '</small>' + (items || '') + '</span>' +
      '<span class="pms-pr"><b>' + price + '</b>' + (was ? '<s>' + was + '</s>' : '') + '</span></button>';
  }
  function thumb(u) { return '<i style="background-image:url(' + esc(img(u, 96)) + ')"></i>'; }
  function picks(list, attr, sel, fits) {
    var h = '<div class="pms-choices">';
    list.slice(0, 12).forEach(function (c, i) {
      h += '<button type="button" class="pms-ch' + (i === sel ? ' is-on' : '') + '" ' + attr + '="' + i + '" aria-label="' + esc(c.p.title) + '" aria-pressed="' + (i === sel) + '" style="background-image:url(' + esc(img(c.v.featured_image || c.p.featured_image, 96)) + ')"></button>';
    });
    h += '</div>';
    var cur = list[sel];
    if (cur) {
      var ci = optIdxColour(cur.p, cur.p._skip), seen = {}, chips = '';
      cur.p.variants.forEach(function (v) {
        if (!v.available || (fits && !fits(v, cur.p))) return;
        var lab = ci < 0 ? v.options.join(' / ') : v.options[ci];
        if (lab) lab = lab.replace(/^balck$/i, 'Black');
        if (!lab || seen[lab]) return;
        seen[lab] = true;
        chips += '<button type="button" class="pms-vc' + (v.id === cur.v.id ? ' is-on' : '') + '" data-vo="' + esc(cur.p.handle) + ':' + v.id + '" aria-pressed="' + (v.id === cur.v.id) + '">' + esc(lab) + '</button>';
      });
      if (Object.keys(seen).length > 1) h += '<div class="pms-vcs">' + chips + '</div>';
    }
    return h;
  }
  function matchLine(c) {
    if (!c) return '';
    if (c.exact) return '<p class="pms-match is-yes">Matches your ' + esc(colourVal()) + ' case</p>';
    return family(colourVal()) ? '<p class="pms-match">Closest style to your ' + esc(colourVal()) + ' case</p>' : '';
  }

  /* ---- guided layout: switch at the top, compact rows, one picker open at a time, pay bar always visible ---- */
  function headHtml(title, sub) {
    return '<div class="pms-grab"></div><div class="pms-head"><div><h3>' + title + '</h3><p>' + sub + '</p></div><button type="button" class="pms-x" data-close aria-label="Close">&times;</button></div>';
  }
  function row(key, u, title, sub, subCls, price, act, open, attn, inner, rmKey) {
    var head = '<i class="pms-ri" style="background-image:url(' + esc(img(u, 104)) + ')"></i><span class="pms-rt"><b>' + title + '</b><small class="' + (subCls || '') + '">' + sub + '</small></span><span class="pms-rp"><b>' + price + '</b>' + (act ? '<em>' + act + '</em>' : '') + (rmKey ? '<span class="pms-rmq" data-rmx="' + rmKey + '" role="button" tabindex="0" aria-label="Remove from set">Remove</span>' : '') + '</span>';
    return '<div class="pms-row' + (open ? ' is-open' : '') + (attn ? ' is-attn' : '') + '">' +
      (key ? '<button type="button" class="pms-row-h" data-toggle="' + key + '" aria-expanded="' + !!open + '">' + head + '</button>' : '<div class="pms-row-h">' + head + '</div>') +
      (open && inner ? '<div class="pms-row-b">' + inner + '</div>' : '') + '</div>';
  }
  function modelChips() {
    var h = '<div class="pms-models">';
    apAvailableModels().forEach(function (m) { h += '<button type="button" class="pms-mdl' + (m === st.apModel ? ' is-on' : '') + '" data-apmodel="' + esc(m) + '" aria-pressed="' + (m === st.apModel) + '">' + esc(m.replace('AirPods ', '')) + '</button>'; });
    return h + '</div>';
  }
  function itemCount(t) { return 1 + (t.wallet ? 1 : 0) + (t.ap ? 1 : 0) + (t.extras ? t.extras.length : 0); }

  function typeRow(k, t, cv, canRemove) {
    var open = st.open === k, rm = canRemove ? '<button type="button" class="pms-rm" data-rmx="' + k + '">Remove from set</button>' : '';
    if (k === 'case') {
      var kc = t.kase;
      if (!kc) return row('', cv.featured_image || main.featured_image, 'Case for your iPhone', 'Which iPhone do you have?', 'is-attn', '&ndash;', '', true, true, phoneChips() + '<button type="button" class="pms-rm" data-rmx="case">Remove from set</button>');
      return row('case', kc.v.featured_image || kc.p.featured_image, esc(kc.p.title), kc.exact ? '&#10003; Matches your ' + esc(colourVal()) : esc(kc.reason || 'Case for ' + modelVal()), kc.exact ? 'is-yes' : '', money(kc.v.price), 'Change', open, false,
        picks(caseCands(), 'data-cspick', Math.min(st.csPick, 11)) + '<button type="button" class="pms-rm" data-rmx="case">Remove from set</button>', canRemove ? k : '');
    }
    if (k === 'wallet') {
      var w = t.wallet;
      return row('wallet', w.v.featured_image || w.p.featured_image, esc(w.p.title), w.exact ? '&#10003; Matches your ' + esc(colourVal()) + ' case' : (family(colourVal()) ? 'Closest style to your case' : 'Fits your set'), w.exact ? 'is-yes' : '', money(w.v.price), 'Change', open, false,
        picks(wlCandidates(), 'data-wlpick', Math.min(st.wlPick, 11)) + rm, canRemove ? k : '');
    }
    if (k === 'airpods') {
      var a = t.ap;
      if (!st.apModel) return row('', a.v.featured_image || a.p.featured_image, 'AirPods case', 'Which AirPods do you have?', 'is-attn', '&ndash;', '', true, true, modelChips() + rm);
      return row('airpods', a.v.featured_image || a.p.featured_image, esc(a.p.title), a.exact ? '&#10003; Matches your ' + esc(colourVal()) + ' case &middot; ' + esc(st.apModel.replace('AirPods ', 'for ')) : 'For ' + esc(st.apModel.replace('AirPods ', '')), a.exact ? 'is-yes' : '', money(a.v.price), 'Change', open, false,
        modelChips() + picks(apCandidates(st.apModel), 'data-appick', Math.min(st.apPick, 11), function (v, p) { return p._skip >= 0 && apModels(v.options[p._skip]).indexOf(st.apModel) !== -1; }) + rm, canRemove ? k : '');
    }
    var x = k === 'strap' ? t.strap : k === 'screen' ? t.screen : t.lens, cands = k === 'strap' ? strapCands() : k === 'screen' ? screenCands() : lensCands(), sel = k === 'strap' ? st.stPick : k === 'screen' ? st.scPick : st.lnPick;
    return row(k, x.v.featured_image || x.p.featured_image, esc(x.p.title), esc(x.reason), 'is-yes', money(x.v.price), 'Change', open, false,
      picks(cands, k === 'strap' ? 'data-stpick' : k === 'screen' ? 'data-scpick' : 'data-lnpick', Math.min(sel, 11)) + rm, canRemove ? k : '');
  }
  function typeTile(k) {
    if (k === 'case' && !phoneNow()) return '<button type="button" class="pms-tile" data-addx="case"><span><b>Case for your iPhone</b><small>Pick your phone to match</small></span><em>+</em></button>';
    var c = typeCands(k), top = c[0], label = k === 'case' ? 'Case for ' + modelVal() : k === 'wallet' ? 'MagSafe wallet' : k === 'airpods' ? 'AirPods case' : k === 'strap' ? 'Strap or lanyard' : k === 'screen' ? 'Screen protector' : 'Camera lens protector';
    if (!top) return '';
    return '<button type="button" class="pms-tile" data-addx="' + k + '"><span><b>' + label + '</b><small>' + money(top.v.price) + (top.reason ? ' &middot; ' + esc(top.reason) : top.exact ? ' &middot; Matches your case' : '') + '</small></span><em>+</em></button>';
  }
  function ringHtml(t) {
    /* counts the layers in the set against the layers this store offers right now; a new kind (screen protector, soon) is one more entry in TYPES */
    var has = { 'case': !!t.kase, wallet: !!t.wallet, airpods: !!t.ap, screen: !!t.screen, strap: !!t.strap, lens: !!t.lens };
    var n = 1, total = 1, miss = '';
    TYPES.forEach(function (k) {
      if (has[k]) { n++; total++; }
      else if (typeAvail(k)) { total++; if (!miss) miss = NAMES[k]; }
    });
    var done = n >= total;
    var title = done ? 'Your set is looking complete' : n >= 3 ? 'Nice set so far' : n === 2 ? 'A great start' : 'Start your set';
    var sub = done ? (n + ' layers, picked for your ' + modelVal() + '.') : (miss ? 'Add a ' + miss + ' to round it out.' : 'Tap Add below to build your set.');
    var len = Math.round(Math.min(n / total, 1) * 163.4);
    return '<div class="pms-ring"><svg width="64" height="64" viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="26" fill="none" stroke="rgba(18,57,43,.15)" stroke-width="8"/><circle class="pms-ring-c" cx="32" cy="32" r="26" fill="none" stroke="#12392b" stroke-width="8" stroke-linecap="round" style="--len:' + len + '" stroke-dasharray="' + len + ' 163.4" transform="rotate(-90 32 32)"/><text x="32" y="37" text-anchor="middle" font-size="15" font-weight="800" fill="#12392b">' + n + '</text></svg><span><b>' + title + '</b><small>' + esc(sub) + '</small></span></div>';
  }
  function undoHtml() {
    if (!st.undo || Date.now() - st.undo.at > 6000) return '';
    var nm = NAMES[st.undo.k] || 'item';
    return '<div class="pms-undo" role="status"><span>' + esc(nm.charAt(0).toUpperCase() + nm.slice(1)) + ' removed</span><button type="button" data-undo>Undo</button></div>';
  }
  function mainSub() { return mIdx >= 0 ? esc(colourVal() || '') + ' &middot; ' + esc(modelVal()) : esc(colourVal() || 'Your pick'); }
  function setRows(t, cv) {
    var h = ringHtml(t);
    h += row('', cv.featured_image || main.featured_image, esc(main.title), mainSub(), '', money(cv.price), '&#10003; Chosen', false, false, '');
    var canRemove = t.items.length > 1;
    TYPES.forEach(function (k) {
      var on = (k === 'case' && (t.kase || (acc && !phoneNow() && st.inc.case))) || (k === 'wallet' && t.wallet) || (k === 'airpods' && t.ap) || (k === 'strap' && t.strap) || (k === 'lens' && t.lens) || (k === 'screen' && t.screen);
      if (on) h += typeRow(k, t, cv, canRemove);
    });
    var tiles = '';
    TYPES.forEach(function (k) { if (!st.inc[k] && typeAvail(k)) tiles += typeTile(k); });
    if (tiles) h += '<div class="pms-eh">Add to your set</div><div class="pms-tiles">' + tiles + '</div>';
    return h + undoHtml();
  }

  function body() {
    if (st.stage === 'pay') return payBody();
    var t = totals(), cv = curVariant(), top, mid = '', price, ready, needAp = false, needPh = false, count = 1;
    var setLabel = halloween ? 'Spooky set' : 'Complete set';
    top = headHtml(st.tier === 'gift' ? 'Gifts for 3' : 'Your set', 'Matched to ' + esc(modelVal())) +
      '<div class="pms-seg" role="tablist">' +
      '<button type="button" class="pms-sg' + (st.tier === 'case' ? ' is-on' : '') + '" data-tier="case" aria-pressed="' + (st.tier === 'case') + '">' + (acc ? 'Just this item' : 'Just the case') + '<small>' + money(cv.price) + '</small></button>' +
      (t.set ? '<button type="button" class="pms-sg' + (st.tier === 'set' ? ' is-on' : '') + '" data-tier="set" aria-pressed="' + (st.tier === 'set') + '">' + setLabel + '<small>' + (t.apGuess ? 'From ' : '') + money(t.set.price) + '</small></button>' : '') +
      (acc ? '' : '<button type="button" class="pms-sg' + (st.tier === 'gift' ? ' is-on' : '') + '" data-tier="gift" aria-pressed="' + (st.tier === 'gift') + '">Gift for 3<small>' + (t.gift ? money(t.gift.price) : 'Pick phones') + '</small></button>') + '</div>';

    if (st.tier === 'case') {
      mid = row('', cv.featured_image || main.featured_image, esc(main.title), mainSub(), '', money(cv.price), '&#10003; Chosen', false, false, '');
      price = cv.price; ready = cv.available; count = 1;
    } else if (st.tier === 'set' && t.set) {
      mid = setRows(t, cv);
      price = t.set.price; needAp = !!t.ap && !st.apModel; needPh = !!(acc && st.inc.case && !phoneNow()); ready = !needAp && !needPh; count = t.set.count;
      if (t.set.saved) mid += '<p class="pms-save">You save ' + money(t.set.saved) + ' on this set</p>';
    } else if (st.tier === 'gift') {
      var gm = giftModels();
      mid = '<div class="pms-opt pms-gifts"><div class="pms-person"><span class="pms-av">You</span><b>' + esc(modelVal()) + '</b><small>' + esc(colourVal() || main.title) + '</small></div>';
      ['Friend', 'Family'].forEach(function (nm, i) {
        mid += '<div class="pms-person"><span class="pms-av">+' + (i + 1) + '</span><b>' + nm + '</b><select data-gift="' + i + '" aria-label="Phone for ' + nm + '"><option value="">Choose phone</option>';
        gm.forEach(function (m) { mid += '<option value="' + esc(m) + '"' + (st.gift[i] === m ? ' selected' : '') + '>' + esc(m) + '</option>'; });
        mid += '</select></div>';
      });
      mid += '</div><p class="pms-hint">Same colour, a phone for each person. We match the fit.</p>';
      price = t.gift ? t.gift.price : 0; ready = !!t.gift; count = 3;
      if (t.gift && t.gift.saved) mid += '<p class="pms-save">You save ' + money(t.gift.saved) + ' on this set</p>';
    } else { mid = ''; price = 0; ready = false; }

    var shipLine = shipText;
    if (price && cur === shopCur && freeFrom && price >= freeFrom) shipLine = 'Free shipping unlocked';
    var codeLn = '', codeApplied = false;
    if (code && codeMin && cur === shopCur && (price || st.tier === 'gift')) {
      /* the code only counts iPhone cases, so wallets and AirPods cases do not add to the minimum */
      /* the code only counts iPhone cases: on an accessory page that is the case add-on, if there is one */
      var eligible = acc ? (t.kase ? t.kase.v.price : 0) : (st.tier === 'gift' ? (t.gift ? t.gift.sum : cv.price) : cv.price);
      var offTxt = (codeText || 'Discount').replace(/[.\s]+$/, ''), cu = code.toUpperCase();
      var tagSvg = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4L11 3.8A2 2 0 009.6 3.2L3 3v6.6a2 2 0 00.6 1.4l9.6 9.6a2 2 0 002.8 0l4.6-4.6a2 2 0 000-2.6z"/><circle cx="7.5" cy="7.5" r="1.2"/></svg>';
      if (eligible >= codeMin) {
        codeApplied = true;
        if (!st.codeOn) { st.codeOn = true; try { fetch('/discount/' + encodeURIComponent(code)); } catch (e) { st.codeOn = true; } }
        codeLn = '<div class="pms-code is-on">' + tagSvg + '<span class="pms-code-t"><b>' + esc(offTxt) + ' on your iPhone cases</b><small>Code ' + esc(cu) + ' is added to your order</small></span><span class="pms-tick" aria-hidden="true">&#10003;</span></div>';
      } else if (acc) {
        codeLn = '';
      } else if (st.tier !== 'gift') {
        codeLn = '<button type="button" class="pms-code pms-code-btn" data-tier="gift">' + tagSvg + '<span class="pms-code-t"><b>' + esc(offTxt) + ' when your iPhone cases total ' + money(codeMin) + '</b><small>Gift for 3 qualifies. Tap to see it</small></span><span class="pms-code-go" aria-hidden="true">&rsaquo;</span></button>';
      } else {
        codeLn = '<div class="pms-code">' + tagSvg + '<span class="pms-code-t"><b>' + esc(offTxt) + ' with 3 cases</b><small>Choose a phone for both to unlock it</small></span></div>';
      }
    }
    var unlocked = !!(price && cur === shopCur && freeFrom && price >= freeFrom);
    if (!unlocked) { st.yay = false; st.yayUntil = 0; }
    else if (!st.yay) { st.yay = true; st.yayUntil = Date.now() + 3800; setTimeout(function () { if (sheet && st.stage !== 'pay') rerender(); }, 3900); }
    var yay = '';
    if (unlocked && Date.now() < st.yayUntil) {
      var conf = '';
      for (var ci2 = 0; ci2 < 16; ci2++) conf += '<i style="--i:' + ci2 + '"></i>';
      yay = '<div class="pms-yay" role="status"><span class="pms-conf" aria-hidden="true">' + conf + '</span><span class="pms-yay-i" aria-hidden="true">&#10003;</span><span class="pms-yay-t"><b>You unlocked free shipping!</b><small>' + (codeApplied ? 'Plus your ' + esc((codeText || 'discount').replace(/[.\s]+$/, '').toLowerCase()) + ' is added.' : 'Your set ships free.') + '</small></span></div>';
    }
    var foot = yay + codeLn + '<div class="pms-sum2"><span>' + count + ' item' + (count === 1 ? '' : 's') + ' &middot; ' + esc(shipLine) + '</span><b>' + (price ? money(price) : '') + '</b></div>';
    if (st.err) foot += '<p class="pms-err" role="alert">' + esc(st.err) + '</p>';
    foot += '<button type="button" class="pms-buy" data-buy' + (ready && !st.busy ? '' : ' disabled') + '>' + (st.busy ? 'One moment' : (needAp ? 'Choose your AirPods to pay' : needPh ? 'Choose your iPhone to pay' : 'Pay now' + (price ? ' &middot; ' + money(price) : ''))) + '</button>' +
      '<div class="pms-foot2"><button type="button" class="pms-cart2" data-cart' + (ready && !st.busy ? '' : ' disabled') + '>Add to cart</button><span>Apple Pay &middot; Google Pay &middot; Shop Pay next</span></div>';
    return '<div class="pms-top">' + top + '</div><div class="pms-scroll">' + mid + '</div><div class="pms-foot">' + foot + '</div>';
  }

  /* pay stage: the set is in the cart, and Shopify's own wallet buttons (Apple Pay, Google Pay, Shop Pay) are shown here */
  function payBody() {
    var total = st.added.reduce(function (n, i) { return n + (i.final_line_price || i.line_price || 0); }, 0);
    var top = headHtml('Pay now', st.added.length + ' item' + (st.added.length === 1 ? '' : 's') + ' &middot; ' + money(total));
    var mid = '<div class="pms-opt pms-sum">';
    st.added.forEach(function (i) {
      mid += '<div class="pms-line"><i style="background-image:url(' + esc(img(i.featured_image && i.featured_image.url || i.image, 96)) + ')"></i><span><b>' + esc(i.product_title) + '</b><small>' + esc(i.variant_title || '') + '</small></span><em>' + money(i.final_line_price || i.line_price || 0) + '</em></div>';
    });
    mid += '</div><div class="pms-eh">Express checkout</div><div class="pms-live" id="pms-live"><p class="pms-live-sk">Loading payment options</p></div><div class="pms-or"><span>or</span></div>';
    var foot = '<button type="button" class="pms-buy" data-checkout>Pay by card &middot; ' + money(total) + '</button><div class="pms-foot2"><button type="button" class="pms-cart2" data-back>Edit my set</button><span>30-day returns &middot; Secure checkout</span></div>';
    return '<div class="pms-top">' + top + '</div><div class="pms-scroll">' + mid + '</div><div class="pms-foot">' + foot + '</div>';
  }
  /* Shopify's wallet buttons (Shop Pay, Apple Pay, Google Pay) come from the cart section. Markup added with innerHTML does not run its scripts,
     so they are re-created here; a slow or empty answer is retried once, and the box never stays on "Loading" */
  function revive(box) {
    [].slice.call(box.querySelectorAll('script')).forEach(function (o) {
      var n = document.createElement('script');
      [].slice.call(o.attributes).forEach(function (at) { n.setAttribute(at.name, at.value); });
      n.text = o.text;
      o.parentNode.replaceChild(n, o);
    });
  }
  function walletsGone(box) {
    if (!box) return;
    box.innerHTML = '<p class="pms-live-sk">Apple Pay, Google Pay and Shop Pay are offered at checkout.</p>';
  }
  function loadWallets(tries) {
    tries = tries || 0;
    var base = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 6000);
    fetch(base + '?section_id=cart-drawer&t=' + Date.now(), ctl ? { signal: ctl.signal, credentials: 'same-origin' } : { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        clearTimeout(timer);
        var box = sheet && sheet.querySelector('#pms-live');
        if (!box) return;
        var d = new DOMParser().parseFromString(html, 'text/html');
        var dyn = d.querySelector('.ipc-dynamic-checkout');
        if (!dyn) { if (tries < 1) { setTimeout(function () { loadWallets(tries + 1); }, 700); } else { walletsGone(box); } return; }
        var dv = dyn.querySelector('.ipc-dynamic-checkout-divider');
        if (dv && dv.parentNode) dv.parentNode.removeChild(dv);
        box.innerHTML = dyn.innerHTML;
        revive(box);
      })
      .catch(function () {
        clearTimeout(timer);
        var box = sheet && sheet.querySelector('#pms-live');
        if (tries < 1) { setTimeout(function () { loadWallets(tries + 1); }, 700); } else { walletsGone(box); }
      });
  }
  function undoAdded() {
    var updates = {};
    st.added.forEach(function (i) { if (i.key) updates[i.key] = 0; });
    st.added = [];
    st.stage = 'pick';
    if (!Object.keys(updates).length) { rerender(); return; }
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) }).catch(function () { /* ignore */ }).then(function () { rerender(); });
  }

  function open() {
    if (sheet) return;
    lastFocus = document.activeElement;
    sheet = document.createElement('div');
    sheet.className = 'pms-overlay';
    sheet.innerHTML = '<div class="pms-sheet" role="dialog" aria-modal="true" aria-label="Choose your set" tabindex="-1">' + body() + '</div>';
    document.body.appendChild(sheet);
    document.documentElement.classList.add('pms-lock');
    requestAnimationFrame(function () { sheet.classList.add('is-in'); var d = sheet.querySelector('.pms-sheet'); if (d) d.focus(); });
    sheet.addEventListener('click', onSheet);
    sheet.addEventListener('change', onChange);
  }
  function close() {
    if (!sheet) return;
    var s = sheet; sheet = null;
    st.stage = 'pick';
    s.classList.remove('is-in');
    document.documentElement.classList.remove('pms-lock');
    setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function rerender() {
    if (!sheet) return;
    var d = sheet.querySelector('.pms-sheet'), sc0 = d.querySelector('.pms-scroll'), y = sc0 ? sc0.scrollTop : 0;
    var oldLive = st.stage === 'pay' ? d.querySelector('#pms-live') : null;
    if (oldLive && !oldLive.querySelector('shopify-accelerated-checkout-cart')) oldLive = null; // keep loaded wallet buttons across a redraw
    d.innerHTML = body();
    if (oldLive) { var nl2 = d.querySelector('#pms-live'); if (nl2 && nl2.parentNode) nl2.parentNode.replaceChild(oldLive, nl2); }
    var sc1 = d.querySelector('.pms-scroll');
    if (sc1) sc1.scrollTop = y;
  }

  function onSheet(e) {
    var t = e.target;
    if (t === sheet || (t.closest && t.closest('[data-close]'))) { close(); return; }
    var vo = t.closest && t.closest('[data-vo]');
    if (vo) { var pv = vo.getAttribute('data-vo').split(':'); st.vo[pv[0]] = +pv[1]; st.touched = true; teaser(); rerender(); return; }
    var tr = t.closest && t.closest('[data-tier]');
    if (tr) { st.tier = tr.getAttribute('data-tier'); st.err = ''; st.open = ''; rerender(); return; }
    var rx0 = t.closest && t.closest('[data-rmx]');
    if (rx0) { ensureInc(); var kk = rx0.getAttribute('data-rmx'); st.inc[kk] = false; st.touched = true; st.open = ''; st.undo = { k: kk, at: Date.now() }; setTimeout(function () { if (sheet && st.undo && Date.now() - st.undo.at >= 6000) { st.undo = null; rerender(); } }, 6100); teaser(); rerender(); return; }
    var ud = t.closest && t.closest('[data-undo]');
    if (ud) { ensureInc(); if (st.undo) st.inc[st.undo.k] = true; st.undo = null; st.touched = true; teaser(); rerender(); return; }
    var tg = t.closest && t.closest('[data-toggle]');
    if (tg) { var k0 = tg.getAttribute('data-toggle'); st.open = st.open === k0 ? '' : k0; rerender(); return; }
    var ax = t.closest && t.closest('[data-addx]');
    if (ax) { var k1 = ax.getAttribute('data-addx'); ensureInc(); st.inc[k1] = true; st.touched = true; st.open = k1; var pcs = k1 === 'case' ? [] : k1 === 'strap' ? strapCands() : k1 === 'lens' ? lensCands() : k1 === 'screen' ? screenCands() : []; if (pcs[0]) rememberExtra(pcs[0].p.handle); teaser(); rerender(); return; }
    var rx = t.closest && t.closest('[data-rmx]');
    if (rx) { ensureInc(); st.inc[rx.getAttribute('data-rmx')] = false; st.touched = true; st.open = ''; teaser(); rerender(); return; }
    var sp = t.closest && t.closest('[data-stpick]');
    if (sp) { st.stPick = +sp.getAttribute('data-stpick'); rerender(); return; }
    var csp = t.closest && t.closest('[data-cspick]');
    if (csp) { st.csPick = +csp.getAttribute('data-cspick'); rerender(); return; }
    var ph = t.closest && t.closest('[data-phone]');
    if (ph) { phone = ph.getAttribute('data-phone'); try { localStorage.setItem('user_selected_device_model', phone); } catch (x) { /* storage blocked */ } st.open = 'case'; loadCases(); teaser(); rerender(); return; }
    var scp = t.closest && t.closest('[data-scpick]');
    if (scp) { st.scPick = +scp.getAttribute('data-scpick'); rerender(); return; }
    var lp = t.closest && t.closest('[data-lnpick]');
    if (lp) { st.lnPick = +lp.getAttribute('data-lnpick'); rerender(); return; }
    var md = t.closest && t.closest('[data-apmodel]');
    if (md) {
      st.apModel = md.getAttribute('data-apmodel'); st.apPick = 0; st.err = ''; st.open = 'airpods';
      try { localStorage.setItem('pm_airpods_model', st.apModel); } catch (x) { /* storage blocked */ }
      teaser(); rerender(); return;
    }
    if (t.closest && t.closest('[data-checkout]')) { window.location.href = '/checkout'; return; }
    if (t.closest && t.closest('[data-back]')) { undoAdded(); return; }
    if (t.closest && t.closest('[data-buy]')) { go(true); return; }
    if (t.closest && t.closest('[data-cart]')) { go(false); return; }
  }
  function onChange(e) {
    var t = e.target;
    if (t.hasAttribute('data-gift')) { st.gift[+t.getAttribute('data-gift')] = t.value; rerender(); }
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  el.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-open]')) open(); });

  /* ---- adding ---- */
  function post(items) {
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
  }
  function lines(withMain) {
    var t = totals(), cv = curVariant(), out = [];
    var props = { _pm_set: st.tier === 'gift' ? 'gift' : 'complete' };
    if (st.tier === 'case') { if (withMain) out.push({ id: cv.id, quantity: 1 }); return out; }
    if (withMain) out.push({ id: cv.id, quantity: 1, properties: props });
    if (st.tier === 'set') {
      (t.items || []).forEach(function (x) { out.push({ id: x.v.id, quantity: 1, properties: props }); });
    } else {
      st.gift.forEach(function (m) { out.push({ id: giftVariant(m).id, quantity: 1, properties: props }); });
    }
    return out;
  }
  function go(buyNow) {
    if (st.busy) return;
    if (!curVariant().available) { st.err = 'This one is sold out. Pick another colour or phone.'; rerender(); return; }
    st.busy = true; st.err = ''; rerender();
    var items = lines(buyNow);
    var run = items.length ? post(items) : Promise.resolve({ ok: true });
    run.then(function (res) {
      if (!res.ok) {
        st.busy = false;
        st.err = (res.j && (res.j.description || res.j.message)) || 'One of the items is no longer available. Pick another and try again.';
        rerender();
        return;
      }
      if (code && codeMin && cur === shopCur) {
        var tot = (res.j && res.j.items ? res.j.items : []).reduce(function (n, i) { return n + (i.final_line_price || 0); }, 0);
        try { fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { if ((c.total_price || tot) >= codeMin) fetch('/discount/' + encodeURIComponent(code)); }); } catch (e) { /* ignore */ }
      }
      if (buyNow) {
        st.added = (res.j && res.j.items) || [];
        st.stage = 'pay'; st.busy = false;
        rerender();
        loadWallets();
        return;
      }
      if (st.tier !== 'case') {
        var inp = document.createElement('input');
        inp.type = 'hidden'; inp.name = 'properties[_pm_set]'; inp.value = st.tier === 'gift' ? 'gift' : 'complete'; inp.setAttribute('data-pms', '');
        form.appendChild(inp);
      }
      st.busy = false;
      close();
      setTimeout(function () {
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        setTimeout(function () { [].slice.call(form.querySelectorAll('[data-pms]')).forEach(function (n) { n.parentNode.removeChild(n); }); }, 1500);
      }, 120);
    }).catch(function () {
      st.busy = false; st.err = 'Could not add the items. Check your connection and try again.'; rerender();
    });
  }

  /* keep prices in step when the shopper changes colour or phone on the page */
  var idInput = form.querySelector('[name="id"]');
  if (idInput) {
    var refresh = function () { st.apPick = 0; st.wlPick = 0; st.stPick = 0; st.lnPick = 0; st.scPick = 0; st.csPick = 0; loadCases(); if (!st.touched) st.inc = null; teaser(); rerender(); };
    form.addEventListener('change', function () { setTimeout(refresh, 60); });
    if (window.MutationObserver) new MutationObserver(refresh).observe(idInput, { attributes: true, attributeFilter: ['value'] });
  }

  /* sticky bottom bar (phones): same two choices as the product page design */
  var bar = null, barShow = false;
  function barText() {
    if (!bar) return;
    var t = totals(), cv = curVariant();
    bar.querySelector('.pms-bar-ship').textContent = 'Ships out 1-3 days';
    var setBtn = bar.querySelector('.pms-bar-set');
    setBtn.hidden = !t.set;
    setBtn.innerHTML = t.set ? 'Make it a set &middot; ' + (t.apGuess ? 'from ' : '') + money(t.set.price) + ' &rsaquo;' : '';
    var mainB = bar.querySelector('.pms-bar-main'), caseB = bar.querySelector('.pms-bar-case');
    mainB.textContent = cv.available ? 'Buy now · ' + money(cv.price) : 'Sold out';
    caseB.textContent = cv.available ? 'Add to cart' : 'Sold out';
    mainB.disabled = caseB.disabled = !cv.available;
    bar.classList.toggle('is-out', !cv.available);
  }
  function barVis() {
    if (!bar) return;
    var on = barShow && !sheet && (el.hidden === false || !curVariant().available);
    bar.hidden = !on;
    document.documentElement.classList.toggle('pms-bar-on', on);
  }
  function buildBar() {
    bar = document.createElement('div');
    bar.className = 'pms-bar';
    bar.hidden = true;
    bar.innerHTML = '<div class="pms-bar-top"><span class="pms-bar-ship"></span><button type="button" class="pms-bar-set" data-open></button></div>' +
      '<div class="pms-bar-row"><button type="button" class="pms-bar-case" data-case></button><button type="button" class="pms-bar-main" data-buynow></button></div>' +
      '<div class="pms-bar-pay">Apple Pay &middot; Google Pay &middot; Shop Pay &middot; 30-day returns</div>';
    document.body.appendChild(bar);
    bar.addEventListener('click', function (e) {
      if (!curVariant().available) return;
      if (e.target.closest('[data-buynow]')) { open(); st.tier = 'case'; go(true); }
      else if (e.target.closest('[data-open]')) open();
      else if (e.target.closest('[data-case]')) { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
    });
    /* the bar shows once the page's own buy button has scrolled away (the Aura view has its own, .au-cta) */
    function watch(btn) {
      if (window.IntersectionObserver && btn) {
        new IntersectionObserver(function (en) { barShow = !en[en.length - 1].isIntersecting; barVis(); }).observe(btn);
      } else { barShow = true; }
    }
    var auWanted = !!document.getElementById('pm-au-data');
    if (auWanted && !document.querySelector('.au-cta')) {
      barShow = true;
      setTimeout(function () { watch(document.querySelector('.au-cta') || form.querySelector('[name="add"]')); }, 900);
    } else {
      watch(document.querySelector('.au-cta') || form.querySelector('[name="add"]'));
    }
    barText(); barVis();
  }
  var _teaser = teaser;
  teaser = function () { _teaser(); barText(); barVis(); };
  var _open = open, _close = close;
  open = function () { _open(); barVis(); };
  close = function () { _close(); setTimeout(barVis, 340); };
  loadCases();
  teaser();
  buildBar();
  window.pmSet = {
    open: function () { open(); },
    buyNow: function () { if (!curVariant().available) return; open(); st.tier = 'case'; go(true); }
  };
})();
